export const HeaderTableDataTransferLogs = [
  'ID',
  'Reference ID',
  'Date Created',
  'Status',
  'Action',
];
